// extracted by mini-css-extract-plugin
export default {"countButton":"GroupTags_countButton__863yo","tag":"GroupTags_tag__X+Liz","addButton":"GroupTags_addButton__azSkT"};